import React from 'react'

import { FiMoreVertical, FiMenu } from 'react-icons/fi'

import style from './Sidebar.module.scss'
import Link from  '~components/Link'

import INTERNATIONAL_SITES from '~models/InternationalSites'

const Sidebar = ({
  microcopy,
  state,
  toggleSidebar,
  hideSidebar
}) => (
  <>
    <button 
      className={style.toggle} 
      data-visible={state.visible}
      data-reactive={state.reactive}
      onClick={toggleSidebar}
      aria-label="Menu"
    >
      <FiMenu /><FiMoreVertical/>
      <span>&nbsp;</span>
    </button>
    <div 
      data-role='sidebar' 
      className={style.sidebar} 
      data-reactive={state.reactive}
      data-visible={state.visible}
    >
      <ul>
        <li className={style.button}>
          <Link to='https://account.box.com/signup/n/developer#ty9l3' microcopy={microcopy}> 
            { microcopy.text('headers.primary.buttons.signup.text', 'Sign Up') }
          </Link>
        </li>
      </ul>
      <ul>
        <li className={style.link}>
          <header>{ microcopy.text('headers.secondary.dropdowns.docs') }</header>
        </li>
        {/* { process.env.GATSBY_FEATURE_GUIDES === 'true' && (
          <li className={style.link}>
            <Link 
              to='/guides/applications/' 
              microcopy={microcopy}
              partiallyActive
            >
              { microcopy.text('headers.primary.links.get_started.text') }
            </Link>
          </li>
        )} */}
        { process.env.GATSBY_FEATURE_GUIDES === 'true' && (
          <li className={style.link}>
            <Link 
              to='/guides/' 
              microcopy={microcopy}
              partiallyActive
            >
              { microcopy.text('headers.primary.links.guides.text') }
            </Link>
          </li>
        )}
        { process.env.GATSBY_FEATURE_REFERENCE === 'true' && (
          <li className={style.link}>
            <Link 
              to='/reference/' 
              microcopy={microcopy}
              partiallyActive
            >
              { microcopy.text('headers.primary.links.api_reference.text') }
            </Link>
          </li>
        )}
        { process.env.GATSBY_FEATURE_PAGES === 'true' && (
          <li className={style.link}>
            <Link 
              to='/sdks-and-tools/' 
              microcopy={microcopy}
              partiallyActive
            >
              { microcopy.text('headers.primary.links.sdks_and_tools.text') }
            </Link>
          </li>
        )}
        { process.env.GATSBY_FEATURE_PAGES === 'true' && (
          <li className={style.link}>
            <Link 
              to='/support/' 
              microcopy={microcopy}
              partiallyActive
            >
              { microcopy.text('headers.primary.links.support.text') }
            </Link>
          </li>
        )}
      </ul>
      <ul>
        <li className={style.link}>
        <header>{ microcopy.text('headers.secondary.dropdowns.elsewhere') }</header>
        </li>
        { Object.entries(microcopy.text('headers.secondary.links', [])).map(([key, link]) => (
          <li key={key} className={style.link}>
            <Link to={ link.url } microcopy={microcopy} onClick={hideSidebar}>
              { link.text }
            </Link>
          </li>
        )) }
      </ul>
      <ul>
        <li className={style.link}>
          <header>{ microcopy.text(`footer.categories.international.title`) }</header>
        </li>
        { INTERNATIONAL_SITES.map((site, index) => (
          <li key={index} className={style.link}>
            <a to={site.url} microcopy={microcopy} onClick={hideSidebar}>
              { site.name }
            </a>
          </li>
        ))}
      </ul>
    </div>
  </>
)

export default Sidebar